import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '../TextField/TextField';
import classes from './calendarInput.module.scss';

const CalendarInput = React.forwardRef((props, ref) => (
  <div className={`${classes.container}`}>
    <TextField
      disabled={props.disabled}
      placeholder={props.label}
      value={props.value}
      onClick={props.onClick}
      error={props.touched && Boolean(props.errors)}
      errorText={props.touched && props.errors}
    />
    {props.showClearBtn && props.value && (
      <div data-testid="clearBtn" role="presentation" className={classes.closeIcon} onClick={props.clearHandler}>
        <CloseIcon fontSize="8px" />
      </div>
    )}
  </div>
));

export default CalendarInput;
